<div class="common__pdf-block-header-figma">
  <div class="common__pdf-block-logo-figma">
      <img class="common__pdf-logo-img-figma"
          [src]="pdfHeader.logoHeader"
          alt="Logo header"/>
  </div>
  <div class="common__pdf-block-header-modified-figma">
      <span>{{pdfHeader.headerModifiedText}}</span>
      <span>{{datePdf | convertDate:'all-with-second'}}</span>
  </div>
</div>
